import React, { Children, cloneElement } from 'react'

import useStyles from './carousel-container.style'

const CarouselContainer = (props) => {
  const { children } = props

  const classes = useStyles()

  const childrenArray = Children.toArray(children)

  const renderChildren = childrenArray.map((child) => {
    return cloneElement(child)
  })

  return <div className={classes.container}>{renderChildren}</div>
}

export default CarouselContainer
